import React from "react"

export default ({style, children}) => (
  <h1 className="page-title" style={style}>{children}</h1>
)